import { graphql } from "gql.tada";
import { RichTextFragment } from "../fragments/RichTextFragment";

export const FAQSectionById = graphql(
  /* GraphQL */ `
    query FAQSectionById($locale: String, $preview: Boolean, $id: String!) {
      faqSection(id: $id, preview: $preview, locale: $locale) {
        ...FAQSectionFragment
      }
    }

    fragment FAQSectionFragment on FaqSection {
      sys {
        id
      }
      faqTitle
      faqFilterTitle
      faqItemsCollectionCollection(limit: 50) {
        items {
          sys {
            id
          }
          faqItemTitle
          faqItemFilterTagText
          faqItemDescriptionRichText {
            ...RichTextFragment
          }
        }
      }
    }
  `,
  [RichTextFragment]
);
